import { render, staticRenderFns } from "./detail-component-dossier.vue?vue&type=template&id=3c2e1b99&scoped=true"
import script from "./detail-component-dossier.vue?vue&type=script&lang=ts"
export * from "./detail-component-dossier.vue?vue&type=script&lang=ts"
import style0 from "./detail-component-dossier.vue?vue&type=style&index=0&id=3c2e1b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e1b99",
  null
  
)

export default component.exports